export const VIDEO_CATEGORIES = ["Music Video", "Short Film", "Visualizer", "Performance", "Lyric Video", "Behind the Scenes", "Animation", "Other"];
export const MAX_VIDEO_BYTES = 200 * 1024 * 1024;
